// extracted by mini-css-extract-plugin
module.exports = {"table":"UsersPage_table__2rpF_"};